<ng-container>
	<lib-tooltip-menu #feedMenu>
		@if (feeds(); as feeds) {
		<div>
			<div libPad [style.min-width]="isMobileView() ? '350px' : '500px'">
				@if (feeds?.length) {
				<div>
					@for (feed of feeds; track feed.id; let first = $first) { @if (!first) {
					<lib-divider class="push-top push-bottom"></lib-divider>
					}
					<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'start'">
						<div libFlexColumn>
							<lib-image
								[alt]="feed.avatarName"
								[avatarName]="feed.avatarName"
								[image]="feed.feedImage"
								[imageSize]="'50px'"
								[maxWidth]="isMobileView() ? 40 : 50"
								[maxHeight]="isMobileView() ? 40 : 50"
							></lib-image>
						</div>
						<div libFlexColumn libFlexFill>
							<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'8px'">
								@if (feed.isNew) {
								<div libFlexColumn class="w-new-feed-badge">new</div>
								}
								<div libFlexColumn libFlexFill libText2>
									{{ feed.title }}
								</div>
								<div libFlexColumn libText5>
									{{ feed.fromNow }}
								</div>
							</div>
							<div libText3>
								<lib-shorten-text [text]="feed.text" [disableShowMoreOrLessButton]="true">
								</lib-shorten-text>
							</div>
						</div>
					</div>
					}

					<div class="w-text-center">
						<lib-divider class="push-top push-bottom"></lib-divider>
						<lib-link [routerLink]="notificationsRouterLink" [linkStyle]="'default'"
							>All notifications</lib-link
						>
					</div>
				</div>
				} @else {
				<lib-message [type]="'info'">You have no notifications</lib-message>
				}
			</div>
		</div>
		}
	</lib-tooltip-menu>
</ng-container>

<ng-template #textLogoDesktopToolbarTemplate>
	@if (appTextLogos(); as appTextLogos) { @if (theme() === 'dark') {
	<lib-image
		[image]="appTextLogos.dark"
		[priority]="true"
		[isRound]="false"
		[alt]="originalAppName()"
		[isResponsive]="true"
		[imageSize]="'original'"
	></lib-image>
	} @else {
	<lib-image
		[image]="appTextLogos.light"
		[priority]="true"
		[isRound]="false"
		[alt]="originalAppName()"
		[isResponsive]="true"
		[imageSize]="'original'"
	></lib-image>
	} }
</ng-template>

<ng-template #textLogoMobileToolbarTemplate>
	@if (appTextLogos(); as appTextLogos) {
	<lib-image
		[image]="appTextLogos.dark"
		[priority]="true"
		[isRound]="false"
		[alt]="originalAppName()"
		[isResponsive]="true"
		[imageSize]="'original'"
	></lib-image>
	}
</ng-template>

@if (layoutType(); as layoutType) {

<!-- Mobile version -->
@if (layoutType === 'mobile') {
<div>
	<div
		class="w-toolbar mobile"
		libFlexRow
		[class.scrolled]="isScrolled()"
		[libFlexRowAlign]="'center'"
		[libFlexRowGap]="'16px'"
	>
		@if (parentRoute(); as parentRoute) {
		<div libFlexColumn>
			<lib-button
				[libTooltip]="'Go back'"
				[iconOnly]="true"
				[icon]="'arrowBack'"
				[routerLink]="parentRoute.routerLink"
			></lib-button>
		</div>
		} @if (calculatedAvatarImage(); as calculatedAvatarImage) {
		<div libFlexColumn>
			<lib-link [routerLink]="dashboardUrl()" [linkStyle]="'noUnderline'">
				<lib-image
					[alt]="title() ?? 'Page title'"
					[imageSize]="'50px'"
					[maxHeight]="40"
					[maxWidth]="40"
					[image]="calculatedAvatarImage"
				></lib-image>
			</lib-link>
		</div>
		}

		<div libFlexColumn libFlexFill>
			<lib-link [routerLink]="dashboardUrl()" [linkStyle]="'noUnderline'">
				@if (title(); as title) { @if (title === originalAppName()) {
				<ng-template [ngTemplateOutlet]="textLogoMobileToolbarTemplate"></ng-template>
				} @else {
				<h2 libLineClamp [clampLines]="subtitle() ? 1 : 2">
					{{ title }}
				</h2>
				@if (subtitle(); as subtitle) {
				<div libText3 libLineClamp [clampLines]="1">
					{{ subtitle }}
				</div>
				} } }
			</lib-link>
		</div>

		<div libFlexColumn>
			<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'0px'">
				@if (buttons(); as buttons) { @if (buttons.length) {
				<div libFlexColumn>
					<lib-button-list
						[singleButtonType]="'mobileToolbar'"
						[buttons]="buttons"
						[mode]="'single'"
					></lib-button-list>
				</div>
				} } @if (toolbarType() === 'default') {
				<div libFlexColumn [libFlexSize]="undefined">
					<lib-button-list
						[buttons]="themeButtons()"
						[singleButtonType]="'mobileToolbar'"
						[mode]="'single'"
						[singleButtonTooltip]="'Switch theme'"
						[moreIcon]="themeButtonIcon()"
					></lib-button-list>
				</div>
				<div libFlexColumn>
					<lib-button
						(click)="openPrimaryMenu()"
						[buttonType]="'mobileToolbar'"
						[iconOnly]="true"
						[icon]="'menu'"
					></lib-button>
				</div>
				} @else if (toolbarType() === 'authPage') {
				<div libFlexColumn>
					<lib-button
						[badge]="unreadFeedsCount() > 0 ? unreadFeedsCount() : undefined"
						(click)="openPrimaryMenu()"
						[buttonType]="'mobileToolbar'"
						[iconOnly]="true"
						[icon]="'menu'"
					></lib-button>
				</div>

				}
			</div>
		</div>
	</div>
</div>

}

<!-- Desktop version -->
@if (layoutType === 'desktop') {

<div class="w-toolbar" [ngClass]="toolbarSizeClass()" [class.scrolled]="isScrolled()">
	<div [ngStyle]="layoutSizeStyles()">
		<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'16px'" class="w-toolbar-row">
			<div libFlexColumn libFlexFill>
				<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'16px'">
					@if (toolbarType() === 'default') { @if (brandLogoImage(); as brandLogoImage) {
					<div libFlexColumn [libFlexSize]="'50px'">
						<lib-link [routerLink]="dashboardUrl()" [linkStyle]="'noUnderline'">
							<lib-image
								[isRound]="false"
								[alt]="'Logo'"
								[priority]="true"
								[imageSize]="'50px'"
								[image]="brandLogoImage"
							></lib-image
						></lib-link>
					</div>
					} } @if (parentRoute(); as parentRoute) {
					<div libFlexColumn>
						<lib-button
							[libTooltip]="'Go back'"
							[iconOnly]="true"
							[icon]="'arrowBack'"
							[routerLink]="parentRoute.routerLink"
						></lib-button>
					</div>
					} @if (title() === originalAppName() && appTextLogos(); as appTextLogos) {
					<a libFlexColumn [routerLink]="dashboardUrl()">
						<ng-template [ngTemplateOutlet]="textLogoDesktopToolbarTemplate"></ng-template>
					</a>
					} @else {
					<div libFlexColumn>
						@if (toolbarType() === 'default') {
						<h1>
							{{ title() }}
						</h1>
						} @else {
						<h2>
							{{ title() }}
						</h2>
						}
					</div>
					}

					<div libFlexColumn libFlexFill>
						<div libFlexRow [libFlexRowGap]="'48px'" [libFlexRowAlign]="'center'">
							@for (menuItem of desktopMenuItems(); track menuItem.title) {
							<div libFlexColumn>
								<lib-link
									[linkStyle]="'noUnderline'"
									[routerLink]="undefined"
									[anchorRoute]="menuItem.anchorRoute"
									[externalUrl]="menuItem.externalUrl"
								>
									<div class="w-toolbar-menu-item">
										{{ menuItem.title }}
									</div>
								</lib-link>
							</div>
							}
						</div>
					</div>

					@if (toolbarType() === 'default' && !authUser()) {
					<div libFlexColumn [libFlexSize]="undefined">
						<lib-button-list
							[buttons]="themeButtons()"
							[mode]="'single'"
							[singleButtonType]="'toolbar'"
							[singleButtonTooltip]="'Switch theme'"
							[moreIcon]="themeButtonIcon()"
						></lib-button-list>
					</div>
					}
				</div>
			</div>
			<ng-container>
				@if (authUser(); as authUser) {
				<lib-tooltip-menu #userMenu>
					<div libPad>
						<div libFlexRow [libFlexRowGap]="'16px'">
							<div libFlexColumn [libFlexSize]="'70px'">
								<lib-link [linkStyle]="'noUnderline'" [routerLink]="avatarRouterLink">
									<lib-image
										[alt]="'User'"
										[maxHeight]="70"
										[maxWidth]="70"
										[imageSize]="'250px'"
										[avatarName]="userMenuTitle()"
										[image]="authUser.avatar"
									></lib-image>
								</lib-link>
							</div>
							<div libFlexColumn [libFlexSize]="'250px'">
								<div>
									@if (userMenuTitle(); as userMenuTitle) {
									<h4>
										{{ userMenuTitle }}
									</h4>
									}
								</div>
								@if (userMenuSubtitle(); as userMenuSubtitle) {
								<div libText5 libLineClamp [clampLines]="1">
									{{ userMenuSubtitle }}
								</div>
								}
							</div>
						</div>
						<lib-divider class="push-top push-bottom"> </lib-divider>
						@for (menuItem of primaryUserMenuItems(); track menuItem.title+menuItem.routerLink; let first
						=$first; let last = $last) {
						<lib-tooltip-menu-item
							[removePadding]="true"
							[removeBorder]="true"
							[typeIcon]="menuItem.iconType"
							[isFirst]="first"
							[isLast]="last"
							(itemClick)="menuItem.click()"
							[routerLink]="menuItem.routerLink"
							[title]="menuItem.title"
						></lib-tooltip-menu-item>
						}

						<lib-divider class="push-top push-bottom"></lib-divider>
						<div>
							<div libText4>Theme</div>
							<div class="push-top-sm">
								<lib-tag-list [tags]="themeTags()"></lib-tag-list>
							</div>
						</div>
						<div class="push-top">
							<div libText4>Preferred unit</div>
							<div class="push-top-sm">
								<mod-user-preferred-unit></mod-user-preferred-unit>
							</div>
						</div>
						<lib-divider class="push-top push-bottom"> </lib-divider>
						@for (menuItem of secondaryUserMenuItems(); track menuItem.title+menuItem.routerLink; let first
						=$first; let last = $last) {
						<lib-tooltip-menu-item
							[removePadding]="true"
							[removeBorder]="true"
							[isFirst]="first"
							[typeIcon]="menuItem.iconType"
							[isLast]="last"
							(itemClick)="menuItem.click()"
							[routerLink]="menuItem.routerLink"
							[title]="menuItem.title"
						></lib-tooltip-menu-item>
						}
					</div>
				</lib-tooltip-menu>

				@if (showTrialButton()) {
				<div libFlexColumn>
					<lib-button [routerLink]="upgradeRouterLink" [icon]="'upgrade'" [buttonType]="'primaryLight'">{{
						trialButtonText()
					}}</lib-button>
				</div>
				} @else if (showLicenceTag()) {
				<div libFlexColumn>
					<lib-link
						[routerLink]="upgradeRouterLink"
						[libTooltip]="'Your active license'"
						[linkStyle]="'noUnderline'"
						[placement]="'bottom'"
					>
						<span class="w-active-license">
							{{ authUser.license }}
						</span>
					</lib-link>
				</div>

				}

				<div libFlexColumn>
					<div libFlexRow [libFlexRowGap]="'0px'">
						<div libFlexColumn>
							<lib-button-list
								[buttons]="themeButtons()"
								[mode]="'single'"
								[singleButtonType]="'toolbar'"
								[singleButtonTooltip]="'Switch theme'"
								[moreIcon]="themeButtonIcon()"
							></lib-button-list>
						</div>

						@if (buttons(); as buttons) { @if (buttons.length) {
						<div libFlexColumn>
							<lib-button-list [buttons]="buttons"></lib-button-list>
						</div>
						} }

						<div
							libFlexColumn
							[libTooltipMenu]="feedMenu"
							[placement]="'bottom'"
							[libTooltip]="'Notifications'"
							[libTooltipMenuPlacement]="'bottom-start'"
							[libTooltipMenuTrigger]="'click'"
							(menuOpened)="handleFeedMenuOpened()"
						>
							<lib-button
								[badge]="unreadFeedsCount() > 0 ? unreadFeedsCount() : undefined"
								[iconOnly]="true"
								[buttonType]="'toolbar'"
								[icon]="'notification'"
							></lib-button>
						</div>
					</div>
				</div>

				<div libFlexColumn>
					<div libFlexRow [libFlexRowGap]="'16px'">
						<div
							class="ui-cursor-pointer"
							libFlexColumn
							[libTooltip]="'Profile'"
							[placement]="'bottom'"
							[libTooltipMenu]="userMenu"
							[libTooltipMenuPlacement]="'bottom-start'"
							[libTooltipMenuTrigger]="'click'"
						>
							<lib-image
								[alt]="'Profile'"
								[priority]="true"
								[imageSize]="'50px'"
								[maxWidth]="40"
								[maxHeight]="40"
								[avatarName]="authUserName()"
								[image]="authUser.avatar"
							></lib-image>
						</div>
					</div>
				</div>

				} @if (!authUser()) {

				<div libFlexColumn>
					<lib-button [routerLink]="loginRouterLink" [buttonType]="'toolbar'">Login</lib-button>
				</div>
				@if (showSignupButton()) {
				<div libFlexColumn>
					<lib-button [routerLink]="signupRouterLink" [buttonType]="'primary'">Sign up</lib-button>
				</div>
				} }
			</ng-container>
		</div>
	</div>
</div>

} }
